import { Card, StatusBadge } from '@chikara/ui';
import { t } from '@/i18n';
import { Card as CardType } from '@/features/card/types/card.types';
import styles from '../../pages/CardDetailPage/CardDetailPage.module.css';

interface CardDetailInfoProps {
    card: CardType;
}

export const CardDetailInfo = ({ card }: CardDetailInfoProps) => {
    return (
        <div className={styles.infoRow}>
            <Card>
                <Card.Stats label={t('dashboard.card.detail.info.email')} value={card.email} />
            </Card>
            <Card>
                <Card.Stats label={t('dashboard.card.detail.info.assignedUser')} value={card.cardholderName} />
            </Card>
            <Card>
                <Card.Stats
                    label={t('dashboard.card.detail.info.type')}
                    value={`${card.typeParse}`}
                    compactTopRight
                    topRightContent={
                        <StatusBadge
                            variant={(card.card_status ? card.card_status : card.status === 'enabled' || card.status === 'disabled' ? card.status : 'inactive') as any}
                            size="xs"
                        >
                            {t(`dashboard.card.status.${ card.card_status || card.status}`) || ''}
                        </StatusBadge>
                    }
                />
            </Card>
            {/* TODO: Aún no está implementada la sección del requester en el back */}
            {/* <Card>
                <Card.Stats
                    label={t('dashboard.card.detail.info.requester')}
                    value={card.requesterName}
                    compactTopRight
                    topRightContent={
                        <StatusBadge
                            variant="inactive"
                            size="xs"
                        >
                            {card.requestDate}
                        </StatusBadge>
                    }
                />
            </Card> */}
        </div>
    );
};
